import { isWeekend } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { useEffect, useState } from 'react';

const useChatWidgetStatus = () => {
  const isChatWidgetEnabled = import.meta.env.REACT_APP_CONSUMER_ENABLE_CHAT_WIDGET === 'true';

  // Determine if support chat should be online
  // only between 9:00am and 4:30pm CT (Central Time) (America/Chicago)
  const [isSupportOnline, setIsSupportOnline] = useState(() => {
    const nowCT = toZonedTime(new Date(), 'America/Chicago');
    return (
      !isWeekend(nowCT) &&
      nowCT.getHours() >= 9 &&
      (nowCT.getHours() < 16 || (nowCT.getHours() === 16 && nowCT.getMinutes() < 30))
    );
  });

  // Update support online status every minute
  useEffect(() => {
    if (isChatWidgetEnabled === false) {
      return undefined;
    }

    const updateSupportOnline = () => {
      const nowCT = toZonedTime(new Date(), 'America/Chicago');
      setIsSupportOnline(
        !isWeekend(nowCT) &&
          nowCT.getHours() >= 9 &&
          (nowCT.getHours() < 16 || (nowCT.getHours() === 16 && nowCT.getMinutes() < 30)),
      );
    };
    updateSupportOnline();
    const intervalId = setInterval(updateSupportOnline, 60000); // update every minute

    return () => clearInterval(intervalId);
  }, [isChatWidgetEnabled]);

  return isChatWidgetEnabled && isSupportOnline;
};

export default useChatWidgetStatus;
